import type { SubmitEditorPluginOptions } from '@atlaskit/editor-plugin-submit-editor/submit-editor-plugin-type';

interface Props {
	options: never;
}

export function submitEditorPluginOptions({}: Props): SubmitEditorPluginOptions | undefined {
	return undefined;
}
